import { state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const MODULE_NAME = 'budgetsystem'

const BudgetSystemModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default BudgetSystemModule



// WEBPACK FOOTER //
// ./src/store/module/budgetsystem/index.js